/* eslint-disable prettier/prettier */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-console */
import api from 'configs/api';

export const postTurbinesOperation = async (params: {
  installationIds: number[];
  supplierExecutors: number[];
  date: string;
  areaType: string;
  type: string;
  order: number[];
}) => {
  const url = `daily-bulletin/turbinesOperation`;

  const parameter = {
    installationIds: params.installationIds,
    supplierExecutors: params.supplierExecutors,
    date: params.date,
    areaType: params.areaType,
    type: params.type,
    order: params.order,
  };

  const { data } = await api.post(url, parameter);

  return data;
};
